
var imcache = {}

function displayPhoto(canvas, photo, parento = {}) {
    let needsRender = false
    if (photo.src && !imcache[photo.src]) {
        let im = imcache[photo.src] = new Image();
        im.tries = 0
        im.onload = () => {
            im.width = im.naturalWidth;
            im.height = im.naturalHeight;
            if (im.height > im.width) {
                let rotatedCanvas = document.createElement('canvas');
                let rotatedCtx = rotatedCanvas.getContext('2d');

                rotatedCanvas.width = im.height;
                rotatedCanvas.height = im.width;
                rotatedCanvas.isLoaded = true;

                rotatedCtx.translate(rotatedCanvas.width / 2, rotatedCanvas.height / 2);
                rotatedCtx.rotate(90 * Math.PI / 180);

                rotatedCtx.drawImage(im, -im.width / 2, -im.height / 2);

                imcache[photo.src] = rotatedCanvas;
                parento.needsRender = true;
            } else {
                im.isLoaded = true;
                parento.needsRender = true;
            }
        }
        im.onerror = () => {
            console.error('image not loaded', photo.src)
            if (im.tries < 30) {
                window.setTimeout(() => {
                    im.tries++
                    im.src = photo.src;
                }, 300 + im.tries * 300 + Math.random() * 300)
            }
        }
        im.src = photo.src;
    }
    if (canvas.ctx) {
        let ctx = canvas.ctx;
        // Get the device pixel ratio
        const dpr = window.devicePixelRatio || 1;

        // Get the CSS width and height of the canvas
        const rect = canvas.getBoundingClientRect();
        const cssWidth = rect.width;
        const cssHeight = rect.height;

        // Calculate the desired canvas dimensions in device pixels
        const desiredWidth = Math.round(cssWidth * dpr);
        const desiredHeight = Math.round(cssHeight * dpr);

        // Only resize if the size differs
        if (canvas.width !== desiredWidth || canvas.height !== desiredHeight) {
            canvas.width = desiredWidth;
            canvas.height = desiredHeight;
        }

        let w = canvas.width;
        let h = canvas.height;
        ctx.fillStyle = '#BBB';
        ctx.fillRect(0, 0, w, h);
        const BW = 10 * dpr
        const BW2 = BW * 2
        const SW = 3 * dpr
        if (photo.src && imcache[photo.src] && imcache[photo.src].isLoaded) {
            photoPosition(photo);
            let im = imcache[photo.src];
            let drawWidth, drawHeight, offsetX, offsetY;
            let bdrawWidth, bdrawHeight, boffsetX = 0, boffsetY = 0;

            let lw = photo.mmw
            let lh = photo.mmh

            let la = lw / lh
            bdrawHeight = h - BW2;
            bdrawWidth = bdrawHeight * la;
            boffsetX = (w - bdrawWidth) / 2;
            boffsetY = BW;
            if (boffsetX < 0) {
                bdrawWidth = w - BW2;
                bdrawHeight = bdrawWidth / la;
                boffsetX = BW;
                boffsetY = (h - bdrawHeight) / 2;
            }

            if (photo.fill == 'fit') {
                w = bdrawWidth + BW2
                h = bdrawHeight + BW2
            }

            // Landscape image
            let imw = photo.cx2 - photo.cx1
            let imh = photo.cy2 - photo.cy1
            let aspectRatio = imw / imh
            drawWidth = w - BW2;
            drawHeight = drawWidth / aspectRatio;
            offsetX = BW;
            offsetY = (h - drawHeight) / 2;
            if (offsetY < 0) {
                drawHeight = h - BW2;
                drawWidth = drawHeight * aspectRatio;
                offsetX = (w - drawWidth) / 2;
                offsetY = BW;
            }

            if (photo.fill == 'fill' || photo.fill == 'mirror') {
                bdrawWidth = drawWidth
                bdrawHeight = drawHeight
                boffsetX = offsetX
                boffsetY = offsetY
            } else {
                offsetX -= BW
                offsetY -= BW
            }

            ctx.fillStyle = 'rgba(0, 0, 0, 0.25)';
            ctx.fillRect(boffsetX + SW, boffsetY + SW, bdrawWidth, bdrawHeight);
            ctx.fillStyle = 'rgba(255, 255, 255, 1)';
            ctx.fillRect(boffsetX, boffsetY, bdrawWidth, bdrawHeight);

            if (photo.fill == 'fill' || photo.fill == 'mirror') {
                ctx.drawImage(im, photo.cx1, photo.cy1, imw, imh, offsetX, offsetY, drawWidth, drawHeight);
            } else {
                ctx.drawImage(im, boffsetX + offsetX, boffsetY + offsetY, drawWidth, drawHeight);
            }

            // Draw a semi-transparent border around the image
            ctx.strokeStyle = 'rgba(200, 200, 200, 0.5)';
            ctx.lineWidth = 1;
            ctx.strokeRect(boffsetX-1, boffsetY-1, bdrawWidth+2, bdrawHeight+2);
            return true

        } else {
            ctx.fillStyle = '#000';
            // Draw rotating progress indicator
            const centerX = canvas.width / 2;
            const centerY = canvas.height / 2;
            const radius = Math.min(canvas.width, canvas.height) * 0.15;
            
            ctx.save();
            ctx.translate(centerX, centerY);
            ctx.rotate((Date.now() / 1000) * Math.PI); // Rotate based on time
            
            ctx.beginPath();
            ctx.arc(0, 0, radius, 0, 1.5 * Math.PI);
            ctx.strokeStyle = 'rgba(255,255,255,0.8)';
            ctx.lineWidth = radius * 0.2;
            ctx.stroke();
            
            ctx.restore();
        }
    }
    return false
}


function photoPosition(photo, generated = false) {
    let imw, imh
    if (generated) {
        imw = photo.data.w
        imh = photo.data.h
    } else {
        let im = imcache[photo.src];
        imw = im.width
        imh = im.height
    }
    if (imh > imw) {
        let tmp = imw
        imw = imh
        imh = tmp
    }
    let im_a = imw / imh
    let lw = photo.mmw
    let lh = photo.mmh
    let cx1 = 0
    let cy1 = 0
    let cx2 = imw
    let cy2 = imh
    if (photo.fill == 'fill' || photo.fill == 'mirror') {
        let place_a = lw / lh
        if (place_a <= im_a) {
            cy1 = 0
            cy2 = imh
            let cw = imh * (lw / lh)
            let posmov = imw - cw
            cx1 = photo.position * posmov
            if (cx1 < 0) { cx1 = 0 }
            cx2 = cx1 + cw
            photo.mh = true
        } else {
            cx1 = 0
            cx2 = imw
            let ch = imw * (lh / lw)
            let posmov = imh - ch
            cy1 = photo.position * posmov
            if (cy1 < 0) { cy1 = 0 }
            cy2 = cy1 + ch
            photo.mh = false
        }
    }
    photo.cx1 = Math.round(cx1)
    photo.cy1 = Math.round(cy1)
    photo.cx2 = Math.round(cx2)
    photo.cy2 = Math.round(cy2)
    photo.w = imw
    photo.h = imh
    return photo
}

const PhotoSizes = {
    // key: mm long, mm short, desc, mode, fix(reel) size, min dpi, medium/reel

    '9x13':  [127,  89, 'kicsi', 'photo', 0, 300, '13'],
    '10x15': [152, 102, 'közepes', 'photo', 0, 300, '15'],
    '15x15': [152, 152, 'közepes négyzet', 'photo', 0, 300, '15'],
    '13x18': [178, 127, 'nagy', 'photo', 1, 300, '13'],
    '15x21': [210, 152, 'óriás', 'photo', 1, 200, '15'],
    '21x21': [210, 210, 'óriás négyzet', 'photo', 0, 200, '21'],
    '21x30': [300, 210, 'A4', 'photo', 1, 200, '21'],
    '30x40': [400, 300, 'közepes', 'print', 0, 150, 'SRA3'], // Mi nyomjuk
    '30x30': [300, 300, 'közepes négyzet', 'print', 0, 150, 'SRA3'], // Mi nyomjuk

    'c35x50': [500, 350, 'közepes', 'canvas', 0, 150, 'canvas'],
    'c50x70': [700, 500, 'gigász', 'canvas', 0, 120, 'canvas'],
    'c35x100': [1000, 350, 'titán vékony', 'canvas', 0, 120, 'canvas'],
    'c50x100': [1000, 500, 'titán keskeny', 'canvas', 0, 120, 'canvas'],
    'c70x100': [1000, 700, 'titán', 'canvas', 0, 100, 'canvas'],    
    'c100x140': [1400, 1000, 'szupertitán', 'canvas', 0, 100, 'canvas'], 

    'c35x35': [350, 350, 'kicsi négyzet', 'canvas', 0, 120, 'canvas'],
    'c50x50': [500, 500, 'nagy négyzet', 'canvas', 0, 120, 'canvas'],
    'c70x70': [700, 700, 'hatalmas négyzet', 'canvas', 0, 100, 'canvas'],
    'c100x100': [1000, 1000, 'titán négyzet', 'canvas', 0, 100, 'canvas'],
    
    '35x50': [500, 350, 'nagy', 'poster', 0, 120, 'poster'],
    '40x50': [500, 400, 'nagy', 'poster', 0, 120, 'poster'],
    '40x60': [600, 400, 'óriás', 'poster', 0, 100, 'poster'],
    '50x70': [700, 500, 'hatalmas', 'poster', 0, 100, 'poster'],
    '61x91': [910, 610, 'gigász', 'poster', 0, 100, 'poster'],
    '70x100': [1000, 700, 'titán', 'poster', 0, 100, 'poster'],
    '75x100': [1000, 750, 'titán', 'poster', 0, 100, 'poster'],
    '100x140': [1400, 1000, 'szupertitán', 'poster', 0, 100, 'poster'],
}

export { displayPhoto, photoPosition, PhotoSizes }
